<template>
<div>
    <!-- <v-app-bar fixed height=65>
        
         <div class="d-flex align-center">
            <v-img
            alt="Vuetify Logo"
            
            :src="storeLogo"
            transition="scale-transition"
            max-height='50'
            max-width="250"
            />
         
         </div>
         <v-spacer></v-spacer>
           <v-btn icon append :to="{name:'Cart'}"> 
                <v-icon>mdi-cart-outline</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>mdi-account-circle-outline</v-icon>
            </v-btn>
        
    </v-app-bar> -->
     <v-img :src="bannerImage" height=700 class='align-center' dark  gradient="to top left, rgba(0,0,0,.2), rgba(0,0,0,.7)">
         
         <v-row justify="center">
             <h1 class='display-1 '>Welcome to <br> <span class='display-3 font-weight-bold'>{{storeName}}</span></h1>
         </v-row>
            
    </v-img>
    <div class='pl-10 pr-10' v-if='false'>
        <h1 class='ml-10 mb-5 mt-10'>Trending today!</h1>
    
        <v-slide-group show-arrows class='pl-5'>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card class='ml-3 mb-3' height=300 width=300 color='primary'></v-card>
            </v-slide-item>
        </v-slide-group>
    </div>
    <v-divider class='mb-5'></v-divider>   

    <v-container class='mt-10'>

        
       
       <div>

            <h1>Our Products</h1>
            <div v-for='category in categories' :key="category.id">
                <Category :categoryName='category.categoryName' :products='category.products'/>
            </div>
            
       </div>    
    </v-container>
    <v-footer color='grey' dark>
        <v-container>
             <p>Address:  <br>
                {{address1}},  <br> 
                {{address2}}, <br>
                {{city}},   <br>
                {{state}}, {{pincode}} 
            </p>
        </v-container>
       
    </v-footer>
</div>

</template>
<script>

/*global myBaseURL*/

import axios from 'axios';
import Category from "@/components/Category.vue"

export default {
    name:"Store",
    components:{
        Category
    },
    data(){
        return{
            storeName:'Store',
            bannerImage:'',
            storeLogo:'',
            categories : [],
            address1 : '',
            address2 : '',
            city : '',
            state : '',
            pincode : ''
        }
    },
    created(){
        this.$emit('showAppBar');
        // var that = this;
         axios.request({
            url: '/store/home/'+this.$route.params.store_slug ,
            method: 'GET',
            baseURL: myBaseURL,
            // headers: {
            //     'Authorization': 'Bearer '+ window.localStorage.access_token
            // }
        }).then(response => {
            this.categories=response.data.data.categories
            this.storeName=response.data.name
            this.bannerImage=response.data.banner
            this.address1 = response.data.address.line1;
            this.address2 = response.data.address.line2;
            this.city = response.data.address.city;
            this.state = response.data.address.state;
            this.pincode = response.data.address.pincode;
            // this.storeLogo=response.data.logo
            // console.log(response.data.slug);
            this.$emit('showLogo',response.data.logo,response.data.slug);
        }).catch(e => {
            console.log(e)
        })

    }
}
</script>